module.exports = __webpack_public_path__ + "img/safe_move02.7e234183.png";